import React, { Component, useState, useRef, useCallback } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Modal, Col, Row, Button, message, InputNumber,Switch,Tooltip } from 'antd'
import dayjs from 'dayjs'
import * as apis from '@/apis'
import {
  QuestionCircleOutlined,
} from '@ant-design/icons';

@Form.create()
class ReferralRuleDialog extends Component {
  state = {
    loading: false,
    cumulative: false,
  }
  handleSubmit = e => {
    const { ismodify, rule = {}, submitCallback, onSuccess } = this.props
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }
      this.setState({ loading: true })
      if(values.maxOrder<values.minOrder){
        message.error('订单范围设置有误')
        this.setState({
          loading: false
        })
        return
      }
      if (ismodify !== "modify") {
        
        apis.createReferralRule({
            maxOrder: values.maxOrder,
            minOrder: values.minOrder,
            days: values.days,
            isActive: this.state.cumulative
        }).then(result => {
          message.success('添加成功')
          this.props.form.resetFields()
          onSuccess(result)
          submitCallback && submitCallback()

        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })
      } else {
        apis.updateReferralRule(rule._id, {
            maxOrder: values.maxOrder,
            minOrder: values.minOrder,
            days: values.days,
            isActive: this.state.cumulative
        }).then(result => {
          message.success('修改成功')
          this.props.form.resetFields()
          onSuccess(result)
          submitCallback && submitCallback()
        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })
      }
    });
  }

  onCumulativeChange = checked => {
    this.setState({cumulative:checked})
  }
  componentDidMount() {

  }

  render() {
    const {  rule = {}, ismodify } = this.props
    const { getFieldDecorator, } = this.props.form
    const disabled = this.state.loading
    const onCumulativeChange = checked => {
      this.setState({cumulative:checked})
    }
    return (
      <div>
        <Form layout="inline" onSubmit={this.handleSubmit}>
          <Row>
            <Col span={24}>
              <Form.Item
                label="最小单数"
                required>
                {getFieldDecorator('minOrder', {
                  initialValue: rule.minOrder,
                  rules: [
                    {
                      required: true,
                      message: '请输入最小单数',
                    },
                  ],
                })(
                  <InputNumber min={0}  parser={text=>/^\d+$/.test(text)?text:0}  style={{ width: 200 }} autoFocus placeholder="请输入最小单数" />
                )}
              </Form.Item>
            </Col>
            </Row>
            <Row>
            <Col span={24}>
              <Form.Item
                label="最大单数"
                required>
                {getFieldDecorator('maxOrder', {
                  initialValue: rule.maxOrder,
                  rules: [
                    {
                      required: true,
                      message: '请输入最大单数',
                    },
                  ],
                })(
                  <InputNumber min={0} parser={text=>/^\d+$/.test(text)?text:0}  style={{ width: 200 }} autoFocus placeholder="请输入最大单数" />
                )}
              </Form.Item>
            </Col>
            </Row>
            <Row>
            <Col span={24}>
              <Form.Item
                label="延期天数"
                required>
                {getFieldDecorator('days', {
                  initialValue: rule.days,
                  rules: [
                    {
                      required: true,
                      message: '请输入延期天数',
                    },
                  ],
                })(
                  <InputNumber min={0} parser={text=>/^\d+$/.test(text)?text:0}  style={{ width: 200 }} autoFocus placeholder="请输入延期天数" />
                )}
                 <Tooltip placement="top" title="过去三个月的月均订单介于最小、最大订单数之间，则可延期佣金返现的天数"><QuestionCircleOutlined style={{marginLeft:5}}/></Tooltip>
              </Form.Item>
            </Col>
            </Row>
            <Row>
            <Col span={24}>
              <Form.Item
                required
                label="是否启用">
                {getFieldDecorator('isActive', {
                  initialValue: rule.isActive,
                  valuePropName: 'checked',
                  rules: [
                    {
                      required: false,
                      message: '是否启用',
                    },
                  ],
                })(
                  <Switch disabled={disabled} onChange={onCumulativeChange} />
                )}
              </Form.Item>
              </Col>
          </Row>
          <Form.Item style={{display:"block", marginTop: 10,textAlign:"center"}}>
                <Button type="primary" disabled={disabled} htmlType="submit">保存</Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

const ReferralRuleInfoDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={380}
    style={{ top: 30 }}
    visible={isOpen}
    maskClosable={false}
    onCancel={hide}>
    <ReferralRuleDialog onSuccess={hide} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'REFERRAL_RULE_DIALOG',
})(ReferralRuleInfoDialog)
